const Hromadny_Email = {
    init: function() {
        var tlacitko = $("#tlacitko-hromadny-email");
        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function(e) {
                e.preventDefault();

                const grid = $("#grid_section_i103");
                const rows = $(grid).jqGrid("getGridParam", "selarrrow");
                if (!rows.length) {
                    Lemo_Alert.addInfo("Pro odeslání emailů označte alespoň jednu žádost", "hromadnyEmailInfo");
                    return;
                }

                let ids = [];
                $.each(rows, function(i, id) {
                    ids.push(id);
                });

                $.ajax({
                    type: "post",
                    url: "/plugin/PluginZadost/hromadnyEmailFormularAjax",
                    dataType: "json",
                    data: { "ids": ids },
                    global: false,
                    beforeSend: function() {
                        Lemo_Alert.closeAll();
                        Lemo_Alert.addInfo("Načítám formulář ...", "hromadnyEmailFormular");
                    },
                    complete: function() {
                        Lemo_Alert.closeById("hromadnyEmailFormular");
                    },
                    success: function(data) {
                        Lemo_Alert.addMany(data.messages);
                        if (
                            false === data["status"]
                            || !data.hasOwnProperty("html")
                            || !data["html"].length
                        ) {
                            return;
                        }

                        // modal
                        Lemo_Modal.setTitle("Hromadný email");
                        Lemo_Modal.setId("modal-hromadny-email");
                        Lemo_Modal.setSize('large');
                        Lemo_Modal.setContent(data.html);
                        Lemo_Modal.addButton("continue", "Odeslat", "btn btn-primary", function() {
                            Lemo_Alert.closeAll();
                            let formData = { "ids": ids };
                            let predmetEmailu = $("#modal-predmetEmailu").val();
                            let textEmailu = $("#modal-textEmailu").val();
                            if (!predmetEmailu.length) {
                                Lemo_Alert.addDanger("Není vyplněn předmět.", "hromadnyEmailFormularChyba");
                                return;
                            }
                            if (!textEmailu.length) {
                                Lemo_Alert.addDanger("Není vyplněn text.", "hromadnyEmailFormularChyba");
                                return;
                            }

                            $.ajax({
                                type: "post",
                                url: "/plugin/PluginZadost/hromadnyEmailFormularAjax",
                                dataType: "json",
                                data: formData,
                                global: false,
                                success: function(r) {
                                    if (r.hasOwnProperty("messages")) {
                                        Lemo_Alert.addMany(r.messages);
                                    }

                                    if (true === r.status) {
                                        Hromadny_Email.akce(textEmailu, predmetEmailu);
                                        Lemo_Modal.close();
                                    }
                                },
                                error: function(xhr) {
                                    Lemo_Alert.addDanger("Došlo k neočekávané chybě");
                                }
                            });
                        });
                        Lemo_Modal.addButton("cancel", "Zrušit", "btn btn-default", function() {
                            Lemo_Alert.closeAll();
                            Lemo_Modal.close();
                        });
                        Lemo_Modal.build();
                    }
                });
            });
    },

    /**
     * @param {object} textEmailu
     */
    akce: function(textEmailu, predmetEmailu) {
        const grid = $("#grid_section_i103");
        const rows = $(grid).jqGrid("getGridParam", "selarrrow");
        if (!rows.length) {
            return;
        }

        let ids = [];
        $.each(rows, function(i, id) {
            ids.push(id);
        });

        const progressId = "hromadny-email-" + Math.round(new Date().getTime() + (Math.random() * 100));

        $.ajax({
            type: "post",
            url: "/plugin/PluginZadost/hromadnyEmailAjax",
            dataType: "json",
            global: true,
            data: { "progressId": progressId, "ids": ids, "textEmailu": textEmailu, "predmetEmailu": predmetEmailu },
            beforeSend: function() {
                let text = "<p id=\"export-progress-eta\">Příprava operace ...</p>";
                text += "<div id=\"export-progress\" class=\"progress text-center mb-3\">";
                text += "    <div class=\"progress-bar progress-bar-animated active\" role=\"progressbar\" style=\"width: 0;\">0%</div>";
                text += "</div>";
                text += "<p id=\"export-progress-message\" class=\"text-monospace\"></p>";

                Lemo_Alert.setShowCloseButton(false);
                Lemo_Alert.setCloseOnClick(false);
                Lemo_Alert.build("info", "Hromadný email", text, "hromadnyEmailProgress", 0);
                Lemo_Alert.setShowCloseButton(true);
                Lemo_Alert.setCloseOnClick(true);

                Plugin_Zadost.progressInterval = window.setInterval(function() {
                    Plugin_Zadost.ajaxProgress(progressId);
                }, 2000);
            },
            success: function(data) {
                if (data.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(data.messages);
                }

                const grid = $("#grid_section_i103");
                grid.trigger("reloadGrid");
            },
            complete: function() {
                Lemo_Alert.closeById("hromadnyEmailProgress");
                if (null !== Plugin_Zadost.progressInterval) {
                    window.clearInterval(Plugin_Zadost.progressInterval);
                    Plugin_Zadost.progressInterval = null;
                }
            }
        });
    }
}

$(document)
    .ready(function() {
        Hromadny_Email.init();
    });
